import React from 'react';
import { XMarkIcon, DocumentIcon } from '@heroicons/react/24/outline';
import { cn } from '../utils/cn';

export interface FilePreviewProps {
  file?: File;
  url?: string;
  fileName?: string;
  fileType?: string;
  onRemove?: () => void;
  className?: string;
}

export const FilePreview: React.FC<FilePreviewProps> = ({
  file,
  url,
  fileName,
  fileType,
  onRemove,
  className,
}) => {
  const name = file?.name || fileName || 'Unknown file';
  const type = file?.type || fileType || '';
  const isImage = type.startsWith('image/') || (url && /\.(jpg|jpeg|png|webp|gif)$/i.test(url));
  const previewUrl = file ? URL.createObjectURL(file) : url;

  return (
    <div className={cn('relative group border rounded-lg overflow-hidden bg-white', className)}>
      {isImage && previewUrl ? (
        <div className="aspect-video w-full relative bg-tiber-100">
          <img
            src={previewUrl}
            alt={name}
            className="w-full h-full object-contain"
          />
        </div>
      ) : (
        <div className="flex items-center p-4 bg-romance-50">
          <DocumentIcon className="h-8 w-8 text-titan mr-3" />
          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium text-juridico truncate">{name}</p>
            {type && <p className="text-xs text-titan truncate">{type}</p>}
          </div>
        </div>
      )}

      {onRemove && (
        <button
          type="button"
          onClick={(e) => {
            e.preventDefault();
            onRemove();
          }}
          className="absolute top-2 right-2 p-1 bg-white rounded-full shadow-sm hover:bg-romance-50 text-titan hover:text-red-500 transition-colors"
        >
          <XMarkIcon className="h-4 w-4" />
        </button>
      )}
    </div>
  );
};
